module.exports = __webpack_public_path__ + "e39b1325f73571c2e6efa0551428a3f3.svg";